const $$splitComponentImporter = () => import('/home/runner/work/touring-host-app/touring-host-app/src/routes/_rootLayout/venues/$id.rental.$version.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
/* eslint-disable @typescript-eslint/no-use-before-define */

import { createTableQuerySchema } from '@common';
import { createFileRoute } from '@tanstack/react-router';
const rentalConfigurationsSearchSchema = createTableQuerySchema({});
export const Route = createFileRoute('/_rootLayout/venues/$id/rental/$version')({
  validateSearch: search => rentalConfigurationsSearchSchema.parse(search),
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});